import { SelectItem } from 'primeng/api';
import { SmartFormConfigurationType } from '../enums';

export class SmartFormConfigurationTypeLookup {

    static getLookup(): SelectItem[] {
        return [
            { label: 'Pre-Anesthesia Evaluation', value: { URL: SmartFormConfigurationType.PreAnesthesiaEvaluation, Title: 'Pre-Anesthesia Evaluation' } },
            { label: 'Intra-Anesthesia Evaluation', value: { URL: SmartFormConfigurationType.IntraAnesthesiaEvaluation, Title: 'Intra-Anesthesia Evaluation' } },
            { label: 'Post-Anesthesia Evaluation', value: { URL: SmartFormConfigurationType.PostAnesthesiaEvaluation, Title: 'Post-Anesthesia Evaluation' } },
            { label: 'Arrive To OT', value: { URL: SmartFormConfigurationType.CheckInToOt, Title: 'Arrive To OT' } },
            { label: 'Start Surgery', value: { URL: SmartFormConfigurationType.CheckInToOr, Title: 'Start Surgery' } },
            { label: 'End Surgery', value: { URL: SmartFormConfigurationType.CheckOutFromOr, Title: 'End Surgery' } },
            { label: 'Operative Note', value: { URL: SmartFormConfigurationType.OperativeNote, Title: 'Operative Note' } },
        ];
    }
}
